import { render, staticRenderFns } from "./V4SupplierAdApprovalsTable.vue?vue&type=template&id=36e1c31a&"
import script from "./V4SupplierAdApprovalsTable.vue?vue&type=script&lang=js&"
export * from "./V4SupplierAdApprovalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports